import React from "react";
const ShuffleSvg = ({ color }) => {
	return (
		<>
			<svg
				// width="800px"
				// height="800px"
				// viewBox="0 0 24 24"
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<g clip-path="url(#clip0_429_11116)">
					<path
						d="M3 17H5.73524C7.14029 17 8.44232 16.2628 9.16521 15.058L12.8348 8.94202C13.5577 7.7372 14.8597 7 16.2648 7H21M21 7L19 5M21 7L19 9"
						// stroke="#292929"
						stroke={color}
						stroke-width="2.5"
						stroke-linecap="round"
						stroke-linejoin="round"
					/>
					<path
						d="M3 7H5.73524C6.82985 7 7.86192 7.44742 8.60636 8.2148M21 17H16.2648C15.1702 17 14.1381 16.5526 13.3936 15.7852M21 17L19 19M21 17L19 15"
						// stroke="#292929"
						stroke={color}
						stroke-width="2.5"
						stroke-linecap="round"
						stroke-linejoin="round"
					/>
				</g>
				<defs>
					<clipPath id="clip0_429_11116">
						<rect width="24" height="24" fill="white" />
					</clipPath>
				</defs>
			</svg>
		</>
	);
};

export default ShuffleSvg;
